// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--8moJ8";
export var symbol = "Footer-module--symbol--JoBNI";